// src/components/Registros/forms/CapacitacionForm.jsx
import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert, InputGroup } from 'react-bootstrap';
import { FaArrowLeft, FaSave, FaTimes, FaDollarSign, FaClock } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import AdjuntosRegistro from '../AdjuntosRegistro';
import { crearDatos } from '../../../api/common';
import SelectMult from '../../SettingNot/SelectMult';
import { useAuth } from '../../../hooks/useAuth';

const CapacitacionForm = ({ onClose, onSubmit, tipoRegistro, solicitante }) => {

  const navigate = useNavigate();
  const {userData}=useAuth()
  const [formData, setFormData] = useState({
    solicitante: solicitante,
    titulo: '',
    nombreCapacitacion: '',
    institucion: '',
    modalidad: 'virtual',
    fechaInicio: '',
    fechaFin: '',
    duracionHoras: '',
    costo: '',
    objetivoCapacitacion: '',
    descripcion: '',
    responsablesAprobacion: [],
    adjuntos: []
  });

  console.log('Tipo de Registro:', formData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const responsables = [
    { id: '1', nombre: 'Juan Pérez', cargo: 'Jefe de Talento Humano' },
    { id: '2', nombre: 'María García', cargo: 'Gerente General' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleResponsableChange = (e) => {
    const { value } = e.target; // value es un array de IDs: ['id1', 'id2', ...]
    
    // Transformar el array de IDs a objetos con la estructura del modelo
    const responsablesFormateados = value?.map((usuarioId, index) => ({
      usuario: usuarioId,
      orden: index + 1,
      estado: 'pendiente'
    }));
    setFormData(prev => ({
      ...prev,
      responsablesAprobacion: responsablesFormateados
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    // Título se autogenera (ver handleSubmit).

    if (!formData.nombreCapacitacion.trim()) {
      newErrors.nombreCapacitacion = 'El nombre de la capacitación es requerido';
    }

    if (!formData.institucion.trim()) {
      newErrors.institucion = 'La institución es requerida';
    }

    if (!formData.fechaInicio) {
      newErrors.fechaInicio = 'La fecha de inicio es requerida';
    }

    if (!formData.fechaFin) {
      newErrors.fechaFin = 'La fecha de fin es requerida';
    }

    if (formData.fechaInicio && formData.fechaFin) {
      if (new Date(formData.fechaFin) < new Date(formData.fechaInicio)) {
        newErrors.fechaFin = 'La fecha fin debe ser mayor o igual a la fecha inicio';
      }
    }

    if (!formData.duracionHoras || formData.duracionHoras <= 0) {
      newErrors.duracionHoras = 'La duración debe ser mayor a 0 horas';
    }

    if (!formData.costo || formData.costo < 0) {
      newErrors.costo = 'El costo debe ser un valor válido';
    }

    if (!formData.objetivoCapacitacion.trim()) {
      newErrors.objetivoCapacitacion = 'El objetivo es requerido';
    }

    if (formData.responsablesAprobacion.length === 0) {
      newErrors.responsablesAprobacion = 'Debe seleccionar al menos un responsable';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: 'error',
        title: 'Errores en el formulario',
        text: 'Por favor, corrija los errores antes de continuar',
        confirmButtonColor: '#0d6efd'
      });
      return;
    }

    setLoading(true);

    try {
      const dataToSubmit = {
        ...formData,
        titulo: 'Solicitud de capacitación',
        tipoSolicitud: 'capacitacion',
        causaInactividad: formData.modalidad === 'presencial'
      };

      await crearDatos('Registro', dataToSubmit);

      await Swal.fire({
        icon: 'success',
        title: 'Solicitud Enviada',
        text: 'Tu solicitud de capacitación ha sido registrada correctamente',
        confirmButtonColor: '#198754'
      });
      if (onSubmit) onSubmit(dataToSubmit);
      navigate('/Solicitudes');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un error al enviar la solicitud. Por favor, intenta nuevamente.',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Los datos ingresados se perderán',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, cancelar',
      cancelButtonText: 'No, continuar'
    }).then((result) => {
      if (result.isConfirmed) {
        onClose();
      }
    });
  };

  return (
    <Container fluid className="py-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh' }}>
      <div className="form-container">
        <div className="form-header" style={{ background: 'linear-gradient(135deg, #198754 0%, #146c43 100%)' }}>
          <div className="d-flex align-items-center">
            <Button variant="light" size="sm" onClick={handleCancel} className="me-3">
              <FaArrowLeft />
            </Button>
            <div>
              <h3 className="mb-0 fw-bold">Solicitud de Capacitación</h3>
              <p className="mb-0 opacity-75">Complete el formulario para solicitar una capacitación o formación</p>
            </div>
          </div>
        </div>

        <div className="form-body">
          <Form onSubmit={handleSubmit}>
            {/* Información Básica */}
            <div className="form-section">
              <h5 className="form-section-title">Información Básica</h5>
              
              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-bold" style={{display:'none'}}>Título (auto)</Form.Label>
                    <Form.Control
                      type="hidden"
                      name="titulo"
                      value={formData.titulo}
                      onChange={handleChange}
                      placeholder="Ej: Solicitud curso de Excel avanzado"
                      isInvalid={!!errors.titulo}
                      maxLength={100}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.titulo}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={8}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Nombre de la Capacitación *</Form.Label>
                    <Form.Control
                      type="text"
                      name="nombreCapacitacion"
                      value={formData.nombreCapacitacion}
                      onChange={handleChange}
                      placeholder="Nombre completo del curso o capacitación"
                      isInvalid={!!errors.nombreCapacitacion}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.nombreCapacitacion}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Modalidad *</Form.Label>
                    <Form.Select
                      name="modalidad"
                      value={formData.modalidad}
                      onChange={handleChange}
                    >
                      <option value="virtual">Virtual</option>
                      <option value="presencial">Presencial</option>
                      <option value="hibrido">Híbrido</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Institución o Proveedor *</Form.Label>
                    <Form.Control
                      type="text"
                      name="institucion"
                      value={formData.institucion}
                      onChange={handleChange}
                      placeholder="Nombre de la institución educativa o empresa"
                      isInvalid={!!errors.institucion}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.institucion}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Fechas y Duración */}
            <div className="form-section">
              <h5 className="form-section-title">Fechas y Duración</h5>
              
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Fecha de Inicio *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaInicio"
                      value={formData.fechaInicio}
                      onChange={handleChange}
                      isInvalid={!!errors.fechaInicio}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fechaInicio}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Fecha de Fin *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaFin"
                      value={formData.fechaFin}
                      onChange={handleChange}
                      isInvalid={!!errors.fechaFin}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fechaFin}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Duración en Horas *</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        name="duracionHoras"
                        value={formData.duracionHoras}
                        onChange={handleChange}
                        placeholder="0"
                        min="1"
                        isInvalid={!!errors.duracionHoras}
                      />
                      <InputGroup.Text>
                        <FaClock />
                      </InputGroup.Text>
                      <Form.Control.Feedback type="invalid">
                        {errors.duracionHoras}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              {formData.modalidad === 'presencial' && (
                <Alert variant="info">
                  <strong>Nota:</strong> Esta capacitación presencial causará inactividad durante el periodo seleccionado.
                </Alert>
              )}
            </div>

            {/* Información Financiera */}
            <div className="form-section">
              <h5 className="form-section-title">Información Financiera</h5>
              
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Costo de la Capacitación *</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FaDollarSign />
                      </InputGroup.Text>
                      <Form.Control
                        type="number"
                        name="costo"
                        value={formData.costo}
                        onChange={handleChange}
                        placeholder="0.00"
                        min="0"
                        step="0.01"
                        isInvalid={!!errors.costo}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.costo}
                      </Form.Control.Feedback>
                    </InputGroup>
                    <Form.Text className="text-muted">
                      Incluir todos los costos: matrícula, materiales, transporte, etc.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
            </div>

                  {/* Responsables */}
            <div className="form-section">
              <h5 className="form-section-title">Asistentes </h5>
              <Form.Group>
                <Form.Label className="fw-bold">Seleccione los asistentes *</Form.Label>
                <SelectMult
                //dataDefault={itemData?.userAutorizados}
                handledata={handleResponsableChange}
                name='asistentes'
                collection={"Usuarios"}
                field={"nombre"}
                baseFilter={[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
                        {
                            "$match": {
                            'status': 'activo'
                            } 
                        },
                        {
                            "$lookup": {
                            "from": "roles",
                            "localField": "role",
                            "foreignField": "_id",
                            "as": "result"
                            }
                        },
                        {
                            "$match": {
                            "result.nombre": { $ne: "Cliente" } 
                            }
                        }
                        ]}
                />
                {errors.responsablesAprobacion && (
                  <Alert variant="danger" className="mt-2 py-2">
                    {errors.responsablesAprobacion}
                  </Alert>
                )}
              </Form.Group>
            </div>

            {/* Justificación */}
            <div className="form-section">
              <h5 className="form-section-title">Justificación y Objetivos</h5>
              
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Objetivo de la Capacitación *</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="objetivoCapacitacion"
                  value={formData.objetivoCapacitacion}
                  onChange={handleChange}
                  placeholder="¿Qué esperas aprender? ¿Cómo beneficiará a tu trabajo y a la empresa?"
                  isInvalid={!!errors.objetivoCapacitacion}
                  maxLength={500}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.objetivoCapacitacion}
                </Form.Control.Feedback>
                <Form.Text className="text-muted">
                  {formData.objetivoCapacitacion.length}/500 caracteres
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Descripción Adicional</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  placeholder="Información adicional sobre la capacitación, temario, certificación, etc."
                  maxLength={500}
                />
                <Form.Text className="text-muted">
                  {formData.descripcion.length}/500 caracteres
                </Form.Text>
              </Form.Group>
            </div>

            {/* Responsables */}
            <div className="form-section">
              <h5 className="form-section-title">Responsables de Aprobación</h5>
              
              <Form.Group>
                <Form.Label className="fw-bold">Seleccione los responsables que deben aprobar *</Form.Label>
                <SelectMult
                //dataDefault={itemData?.userAutorizados}
                handledata={handleResponsableChange}
                name='responsablesAprobacion'
                collection={"Usuarios"}
                field={"nombre"}
                baseFilter={[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
                        {
                            "$match": {
                            'status': 'activo'
                            } 
                        },
                        {
                            "$lookup": {
                            "from": "roles",
                            "localField": "role",
                            "foreignField": "_id",
                            "as": "result"
                            }
                        },
                        {
                            "$match": {
                            "result.nombre": { $ne: "Cliente" } 
                            }
                        }
                        ]}
                />
                {errors.responsablesAprobacion && (
                  <Alert variant="danger" className="mt-2 py-2">
                    {errors.responsablesAprobacion}
                  </Alert>
                )}
              </Form.Group>
            </div>

            <div className="form-section">
              <h5 className="form-section-title">Adjuntos</h5>
              <AdjuntosRegistro
                tipoSolicitud="capacitacion"
                adjuntos={formData.adjuntos}
                onChange={(arr) => setFormData(prev => ({ ...prev, adjuntos: arr }))}
                disabled={loading}
              />
            </div>

            {/* Botones */}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button 
                variant="secondary" 
                onClick={handleCancel}
                disabled={loading}
                className="px-4"
              >
                <FaTimes className="me-2" />
                Cancelar
              </Button>
              <Button 
                variant="primary" 
                type="submit"
                disabled={loading}
                className="px-4"
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Enviando...
                  </>
                ) : (
                  <>
                    <FaSave className="me-2" />
                    Enviar Solicitud
                  </>
                )}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default CapacitacionForm;